import React from 'react'
import { useLocation } from 'react-router-dom'
import OnboardingStep from './OnboardingStep'
import { getStepForRoute } from '../../utils/onboardingRoutes'
import { getStepComponent } from './StepComponents'

const DynamicOnboardingStep: React.FC = () => {
  const location = useLocation()
  const stepKey = getStepForRoute(location.pathname)

  if (!stepKey) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Paso no encontrado
          </h2>
          <p className="text-gray-600">
            La ruta "{location.pathname}" no corresponde a un paso válido del
            onboarding.
          </p>
        </div>
      </div>
    )
  }

  const StepComponent = getStepComponent(stepKey)

  if (!StepComponent) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Componente no disponible
          </h2>
          <p className="text-gray-600">
            El componente para el paso "{stepKey}" no está disponible.
          </p>
        </div>
      </div>
    )
  }

  return (
    <OnboardingStep>
      <StepComponent />
    </OnboardingStep>
  )
}

export default DynamicOnboardingStep
